<p-dialog
  [header]="modalTitle"
  [modal]="modal"
  [(visible)]="visible"
  [position]="position"
  [style]=""
  [maximizable]="maximizable"
  [dismissableMask]="dismissableMask"
  [closeOnEscape]="closeOnEscape"
  (onHide)="onDialogHide()"
>
  <div [ngClass]="contentStyleClass ? contentStyleClass : null">
    <ng-container #dynamicComponentRef></ng-container>
  </div>
</p-dialog>
